
import EventPublisher from "../utils/EventPublisher";
import SecureRequestExecuter from "./requestExecuters/SecureRequestExecuter";
import SecureResponseHandler from "./ResponseHandlers/SecureResponseHandler";
import ActionResultEvents from "../constants/events/ActionResultEvents";


class MemberResponse {

    constructor(
        memberId,
        authSystemId,
        authSystemName,
        authSystemUserId,
        profileCreated,
        emailVerified,
        smsVerified,
        created,
        updated,
        deleted
    ) {
        this.memberId = memberId;
        this.authSystemId = authSystemId;
        this.authSystemName = authSystemName;
        this.authSystemUserId = authSystemUserId;
        this.profileCreated = profileCreated;
        this.emailVerified = emailVerified;
        this.smsVerified = smsVerified;
        this.created = created;
        this.updated = updated;
        this.deleted = deleted;
    }
}

export default class MemberAPIClient {
    constructor() {
        this.getMemberResponseHandler =
            new SecureResponseHandler(
                new Map()
                    .set("MEMBER_COLLECTED", this.onMemberLoaded));
    }

    getMember() {
        SecureRequestExecuter.executeGETRequest(
            "/api/private/member",
            {},
            {},
            this.getMemberResponseHandler);
    }

    onMemberLoaded = (responseHeaders, responseBodyContents, dataFromAction) => {
        EventPublisher.publish(
            ActionResultEvents.MEMBER_LOADED,
            new MemberResponse(
                responseBodyContents["member_id"],
                responseBodyContents["auth_system_id"],
                responseBodyContents["auth_system_name"],
                responseBodyContents["auth_system_user_id"],
                responseBodyContents["profile_created"],
                responseBodyContents["email_verified"],
                responseBodyContents["sms_verified"],
                responseBodyContents["created"],
                responseBodyContents["updated"],
                responseBodyContents["deleted"]));
    };

}